import translate from './translate';

export default {
  install(Vue) {
    Vue.filter('translate', translate);
  },
};
